import { render, staticRenderFns } from "./MedicinesTypeAdd.vue?vue&type=template&id=540eeae0&scoped=true&"
import script from "./MedicinesTypeAdd.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540eeae0",
  null
  
)

export default component.exports